import { Pipe, PipeTransform } from '@angular/core';
import { RoomPriceOption } from '@rx-applications/clientsite/shared/utils';
import { RoomSelectSortBy } from '@rx-applications/clientsite/shared/config/utils';

@Pipe({
  name: 'rxSortRoomPrice',
  standalone: true,
})
export class RxSortRoomPrice implements PipeTransform {
  public transform(value: RoomPriceOption[], sortBy: RoomSelectSortBy) {
    if (sortBy === 'price') {
      return value.sort((a, b) => a.priceDetails.sellPrice - b.priceDetails.sellPrice);
    } else {
      return value;
    }
  }
}
